import React, { useEffect, useState } from 'react'
import firebase from 'firebase/app'
import 'firebase/database'
import { Round } from 'types/Round'
import styles from './electionOverview.m.scss'
import { Election } from './components/election/election'
import { NoDataYet } from './components/noDataYet'

// Get URL parameter, must be done only once
const location = new URL(window.location.href)
const who = location.searchParams.get('who')

// Set up Firebase
const config = {
  apiKey: 'AIzaSyDK2K4LgTvb2KcTE6bUMDElqGxYKCLlo-c',
  authDomain: 'ta-interaktiv.firebaseapp.com',
  databaseURL: 'https://ta-interaktiv.firebaseio.com',
  projectId: 'ta-interaktiv',
  storageBucket: 'ta-interaktiv.appspot.com',
  messagingSenderId: '389633880800'
}

firebase.initializeApp(config)
const projectRoot = firebase.database().ref('2019/bundesratswahl/' + who)

// Create a function for the useEffect
const createWatcher = (property: string, setter: Function) => () => {
  const ref = projectRoot.child(property)
  const watcher = ref.on('value', snapshot => {
    setter(snapshot.val())
  })

  // return a function that turns the watcher off
  return () => {
    ref.off('value', watcher)
  }
}

export function ElectionOverview() {
  // Use a state for the rounds data
  const [rounds, setRounds] = useState<Round[]>()

  // Create watchers for all relevante properties
  useEffect(
    createWatcher(
      'rounds',
      // transform the object to an array
      (roundsObject: { [key: string]: Round }) => {
        setRounds(Object.values(roundsObject))
      }
    ),
    []
  )

  return (
    <div className={styles.overview}>
      {(rounds && rounds.length > 0 && <Election rounds={rounds} />) || (
        <NoDataYet />
      )}
    </div>
  )
}
